/**
 * Ein Meilenstein im Kalender (F-25): Raute in Bereichsfarbe, Punkt fuer die
 * Projektprioritaet (D-03), erreichte durchgestrichen. Ein Klick fuehrt zur
 * Projektseite; mit der Maus laesst er sich auf einen anderen Tag ziehen.
 */
import { Link } from 'react-router-dom';
import { Diamond } from 'lucide-react';

import { useAreaColor } from '@/modules/areas/useAreas';
import { PriorityDot } from '@/ui/composites/PriorityDot';
import { pfad } from '@/app/fokus';
import { formatDate } from '@/lib/datetime';
import { cn } from '@/lib/utils/cn';
import { beginMeilensteinZiehen } from '@/modules/projects/meilensteine/meilensteinZiehen';
import type { MeilensteinItem } from '@/domain/projects/meilensteine';

export function MeilensteinEintrag({ m }: { m: MeilensteinItem }) {
  const areaColor = useAreaColor();
  const text = `Meilenstein ${m.title} (Projekt ${m.projektTitel}), ${formatDate(m.date)}${m.done ? ', erreicht' : ''}`;
  return (
    <Link
      to={pfad.projekt(m.projectId)}
      title={`${text} – zum Verschieben auf einen anderen Tag ziehen`}
      aria-label={text}
      draggable={false}
      onPointerDown={(e) => beginMeilensteinZiehen(e, m)}
      className={cn('flex w-full min-w-0 cursor-grab select-none items-center gap-1 rounded px-1 py-px text-left text-[11px] hover:bg-surface-raised', m.done && 'opacity-55')}
    >
      <Diamond className={cn('size-3 shrink-0', !m.done && 'fill-current')} style={{ color: areaColor(m.areaId) }} aria-hidden="true" />
      <span className={cn('truncate text-ink', m.done && 'line-through')}>{m.title}</span>
      {!m.done && <PriorityDot priority={m.priority} dekorativ className="ml-auto scale-75" />}
    </Link>
  );
}
